// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"lfa-z"};